// extracted by mini-css-extract-plugin
export default {"label":"styles_label__JL1rJ","description":"styles_description__E42eS"};